import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActualProduction = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.1667 37.5001C29.384 37.5001 37.6667 29.2174 37.6667 19.0001C37.6667 8.78282 29.384 0.500092 19.1667 0.500092C8.94942 0.500092 0.666687 8.78282 0.666687 19.0001C0.666687 29.2174 8.94942 37.5001 19.1667 37.5001ZM8.66669 23.9835L16.8063 15.9122L21.2067 20.2462L26.9265 14.6671H24.0671V12.5001H30.6667V19.0001H28.4665V16.1837L21.2067 23.3331L16.8063 19.0001L10.2067 25.5001L8.66669 23.9835Z",
		fill: "{fill}"
	})
});
export default SvgActualProduction;
